import React, { useState, useEffect } from "react";
import { getIncentiveList, getSalarySlip } from "./Services/PayrollService";
import {
  useHistory,
  useParams,
} from "react-router-dom/cjs/react-router-dom.min";
import { GetMasterTypeData } from "../../../Services/Global-Services/GlobalServices";
import { getEmployeeList } from "../EmployeeList/Service/employeeService";

const SalarySlip = () => {
  const [selectedEmployee, setSelectedEmployee] = useState(0);
  const [selectedPeriod, setSelectedPeriod] = useState("");
  let userDetails = JSON.parse(localStorage.getItem("User") || "{}");
  const { EmpId } = useParams();
  const { month } = useParams();
  const [ArrearManagementList, setArrearManagementList] = useState([]);
  const [masterMonthList, setMasterMonthList] = useState([]);
  const [salarySlipEmployee, setSalarySlipEmployee] = useState([]);
  const [salarySlipDeductions, setSalarySlipDeductions] = useState([]);
  const [salarySlipEarnings, setSalarySlipEarnings] = useState([]);
  const [salarySlipSummary, setSalarySlipSummary] = useState([]);
  const [employeeList, setEmployeList] = useState([]);
  const history = useHistory();

  useEffect(() => {
    GetMasterMonth();
    fetchEmployeeIdData();
  }, []);

  async function GetSalarySlip(selectedMonth) {
    let params = {
      EmpId: Number(EmpId),
      ZoneId: 0,
      RegionId: 0,
      MonthDate: `${selectedMonth?.Code}-01`,
    };
    try {
      let res = await getSalarySlip(params);
      setSalarySlipEmployee(res?.Data?.Employee);
      setSalarySlipDeductions(res?.Data?.Deductions);
      setSalarySlipEarnings(res?.Data?.Earnings);
      setSalarySlipSummary(res?.Data?.Summary);
    } catch (error) {
      console.error("Error fetching salary slip:", error);
    }
  }

  async function GetMasterMonth() {
    let params = {
      masterType: "formonth",
      allRecords: true,
      organisationId: userDetails?.OrgId,
    };

    try {
      const response = await GetMasterTypeData(params);
      console.log(response, month, "master month list-----");
      setMasterMonthList(response?.Data || []);
      setSelectedPeriod(Number(month));
      const selectedMonth = response?.Data.filter(
        (m) => m.Id === Number(month),
      );
      console.log(selectedMonth, "selectedMonth--------");
      GetSalarySlip(selectedMonth[0]);
    } catch (error) {
      console.error("Error fetching master month list:", error);
    }
  }

  async function fetchEmployeeIdData() {
    var params = {
      OrganisationId: userDetails?.OrgId,
      LoggedInEmployeeId: userDetails?.EmpId,
      IsDirectReportOrHierarchy: 0,
      SearchText: "",
      FollowersOnly: 0,
      FollowingsOnly: 0,
      IsExEmployeesAlso: 0,
      pageNumber: 1,
      pageSize: 10000,
      EmployeeId: 0,
      IsSuggestedOnly: 0,
    };
    // setIsloading(true);
    try {
      let employeesList = await getEmployeeList(params);
      setEmployeList(employeesList.Data);
      // setIsloading(false);
    } catch (error) {
      // setIsloading(false);
    }
  }

  const empData = [
    {
      name: "Ravindra Kumar",
      eid: "OG0054",
      desig: "Sr. Engineer",
      dept: "Engineering",
      doj: "30 Oct 2018",
      pan: "DYQPR3447M",
      uan: "101201354013",
      bank: "1163",
      regime: "New",
      awd: 28,
      lop: 0,
      earnings: [
        { label: "Basic (40%)", struct: 40522, earned: 40522 },
        { label: "House Rent Allowance", struct: 20261, earned: 20261 },
        { label: "Special Allowance", struct: 49994, earned: 49994 },
        { label: "Statutory Bonus", struct: 5000, earned: 5000 },
        { label: "Meal Reimbursement", struct: 2200, earned: 2200 },
        { label: "Mobile Reimbursement", struct: 500, earned: 500 },
        { label: "Internet Reimbursement", struct: 500, earned: 500 },
      ],
      additions: [
        { label: "Variable Pay", amount: 8000 },
        { label: "Retention Bonus", amount: 0 },
        { label: "Arrear", amount: 12000 },
        { label: "Advance Paid", amount: 0 },
      ],
      employer: [
        { label: "PF — Employer Share", struct: 1800, earned: 1800 },
        { label: "ESIC — Employer Share", struct: 0, earned: 0 },
      ],
      deductions: [
        {
          label: "PF — Employee Share (12% of Basic, max ₹1,800)",
          amount: 1800,
        },
        { label: "ESIC — Employee Share", amount: 0 },
        { label: "Professional Tax", amount: 200 },
        { label: "TDS (Income Tax)", amount: 6965 },
        { label: "Loan Deduction", amount: 5000 },
        { label: "Food Coupon", amount: 1500 },
        { label: "Others", amount: 0 },
      ],
      f16: {
        basic_annual: 486264,
        hra_annual: 243132,
        spec_annual: 599928,
        bonus_annual: 60000,
        reimb_annual: 38400,
        hra_exemption: 243132,
        std_ded: 75000,
        invest_80c: 43200,
        invest_nps: 50000,
        invest_mediclaim: 25000,
        taxable_income: 1264332,
        tax_total: 69650,
        cess: 2786,
        tax_with_cess: 72436,
        tds_ytd: 62685,
        regime: "New",
        slabs: [
          { range: "0 – ₹3,00,000 @ 0%", tax: 0 },
          { range: "₹3L – ₹7L @ 5%", tax: 20000 },
          { range: "₹7L – ₹10L @ 10%", tax: 30000 },
          { range: "₹10L – ₹12L @ 15%", tax: 30000 },
          { range: "₹12L – ₹15L @ 20%", tax: 0 },
          { range: "Above ₹15L @ 30%", tax: 0 },
        ],
      },
    },
    {
      name: "Rohit Yadav",
      eid: "OG0055",
      desig: "Product Manager",
      dept: "Product",
      doj: "02 Nov 2019",
      pan: "AHIPY6466H",
      uan: "100242517175",
      bank: "4244",
      regime: "New",
      awd: 26,
      lop: 2,
      earnings: [
        { label: "Basic (40%)", struct: 21000, earned: 19500 },
        { label: "House Rent Allowance", struct: 10500, earned: 9750 },
        { label: "Special Allowance", struct: 23500, earned: 21786 },
        { label: "Statutory Bonus", struct: 5000, earned: 4643 },
        { label: "Meal Reimbursement", struct: 2200, earned: 0 },
        { label: "Mobile Reimbursement", struct: 500, earned: 0 },
        { label: "Internet Reimbursement", struct: 500, earned: 0 },
      ],
      additions: [
        { label: "Variable Pay", amount: 0 },
        { label: "Retention Bonus", amount: 0 },
        { label: "Arrear", amount: 0 },
        { label: "Advance Paid", amount: 0 },
      ],
      employer: [
        { label: "PF — Employer Share", struct: 1800, earned: 1800 },
        { label: "ESIC — Employer Share", struct: 0, earned: 0 },
      ],
      deductions: [
        {
          label: "PF — Employee Share (12% of Basic, max ₹1,800)",
          amount: 1800,
        },
        { label: "ESIC — Employee Share", amount: 0 },
        { label: "Professional Tax", amount: 200 },
        { label: "TDS (Income Tax)", amount: 3600 },
        { label: "Loan Deduction", amount: 5000 },
        { label: "Food Coupon", amount: 0 },
        { label: "Others", amount: 0 },
      ],
      f16: {
        basic_annual: 252000,
        hra_annual: 126000,
        spec_annual: 282000,
        bonus_annual: 60000,
        reimb_annual: 0,
        hra_exemption: 126000,
        std_ded: 75000,
        invest_80c: 43200,
        invest_nps: 0,
        invest_mediclaim: 15000,
        taxable_income: 645000,
        tax_total: 17250,
        cess: 690,
        tax_with_cess: 17940,
        tds_ytd: 32400,
        regime: "New",
        slabs: [
          { range: "0 – ₹3,00,000 @ 0%", tax: 0 },
          { range: "₹3L – ₹7L @ 5%", tax: 17250 },
          { range: "₹7L – ₹10L @ 10%", tax: 0 },
          { range: "₹10L – ₹12L @ 15%", tax: 0 },
          { range: "₹12L – ₹15L @ 20%", tax: 0 },
          { range: "Above ₹15L @ 30%", tax: 0 },
        ],
      },
    },
  ];

  const currentEmployee = empData[selectedEmployee];

  // Utility functions
  const rup = (n) =>
    n ? `₹${n.toLocaleString("en-IN")}` : '<span style="color:#aaa">—</span>';
  const rupT = (n) => (n ? n.toLocaleString("en-IN") : "—");

  const numToWords = (n) => {
    if (!n) return "Zero Rupees Only";
    const a = [
      "",
      "One",
      "Two",
      "Three",
      "Four",
      "Five",
      "Six",
      "Seven",
      "Eight",
      "Nine",
      "Ten",
      "Eleven",
      "Twelve",
      "Thirteen",
      "Fourteen",
      "Fifteen",
      "Sixteen",
      "Seventeen",
      "Eighteen",
      "Nineteen",
    ];
    const b = [
      "",
      "",
      "Twenty",
      "Thirty",
      "Forty",
      "Fifty",
      "Sixty",
      "Seventy",
      "Eighty",
      "Ninety",
    ];

    const iW = (num) => {
      if (!num) return "";
      if (num < 20) return a[num] + " ";
      if (num < 100)
        return (
          b[Math.floor(num / 10)] + " " + (num % 10 ? a[num % 10] + " " : "")
        );
      if (num < 1000)
        return (
          a[Math.floor(num / 100)] +
          " Hundred " +
          (num % 100 ? iW(num % 100) : "")
        );
      if (num < 100000)
        return (
          iW(Math.floor(num / 1000)) +
          " Thousand " +
          (num % 1000 ? iW(num % 1000) : "")
        );
      if (num < 10000000)
        return (
          iW(Math.floor(num / 100000)) +
          " Lakh " +
          (num % 100000 ? iW(num % 100000) : "")
        );
      return (
        iW(Math.floor(num / 10000000)) +
        " Crore " +
        (num % 10000000 ? iW(num % 10000000) : "")
      );
    };

    return iW(Math.round(n)).trim() + " Rupees Only";
  };

  // Calculate values
  const grossS = currentEmployee.earnings.reduce((a, r) => a + r.struct, 0);
  const grossE = currentEmployee.earnings.reduce((a, r) => a + r.earned, 0);
  const additionsE = currentEmployee.additions.reduce(
    (a, r) => a + r.amount,
    0,
  );

  const erGrossS = currentEmployee.employer.reduce((a, r) => a + r.struct, 0);
  const erGrossE = currentEmployee.employer.reduce((a, r) => a + r.earned, 0);

  const totalDedEmp = currentEmployee.deductions.reduce(
    (a, r) => a + r.amount,
    0,
  );
  const netPay = grossE + additionsE - totalDedEmp;
  const totalCtcDed = totalDedEmp + erGrossE;

  // Render Earnings Table Body
  const renderEarnings = () => {
    let html = salarySlipEarnings
      .map(
        (r) => `
      <tr>
        <td>${r.ComponentName}</td>
        <td style="text-align:right;color:var(--text-muted)">${rup(r.EarnedAmount)}</td>
        <td style="text-align:right">${r.EarnedAmount ? rup(r.EarnedAmount) : '<span style="color:#aaa">—</span>'}</td>
      </tr>
    `,
      )
      .join("");

    const activeAdditions = currentEmployee.additions.filter(
      (r) => r.amount > 0,
    );
    if (activeAdditions.length > 0) {
      html += `
        <tr style="background:#f0fdf4">
          <td colspan="3" style="padding:3px 12px;font-size:10.5px;font-weight:700;color:#166534;text-transform:uppercase;letter-spacing:.4px">
            Additions
          </td>
        </tr>
      `;
      html += activeAdditions
        .map(
          (r) => `
        <tr style="background:#f9fffc">
          <td style="color:#166534">${r.label}</td>
          <td style="text-align:right;color:#aaa">—</td>
          <td style="text-align:right;color:#166534;font-weight:600">${rup(r.amount)}</td>
        </tr>
      `,
        )
        .join("");
    }

    return html;
  };

  // Render Employer Earnings
  const renderEmployerEarnings = () => {
    return currentEmployee.employer
      .filter((r) => r.struct > 0)
      .map(
        (r) => `
      <tr style="background:#f8f9ff">
        <td style="color:#555">${r.label}</td>
        <td style="text-align:right;color:#888">${rup(r.struct)}</td>
        <td style="text-align:right;color:#555">${rup(r.earned)}</td>
      </tr>
    `,
      )
      .join("");
  };

  // Render Deductions
  const renderDeductions = () => {
    return salarySlipDeductions
      .map(
        (r) => `
      <tr>
        <td>${r.ComponentName}</td>
        <td style="text-align:right">${r.Amount ? rup(r.Amount) : '<span style="color:var(--text-muted)">N/A</span>'}</td>
      </tr>
    `,
      )
      .join("");
  };

  // Render Employer Deductions
  const renderEmployerDeductions = () => {
    return currentEmployee.employer
      .filter((r) => r.earned > 0)
      .map(
        (r) => `
      <tr style="background:#f8f9ff">
        <td style="color:#555">${r.label}</td>
        <td style="text-align:right;color:#555">${rup(r.earned)}</td>
      </tr>
    `,
      )
      .join("");
  };

  // Build TDS Summary
  const buildTDS = () => {
    const f = currentEmployee.f16;
    const totalGross =
      f.basic_annual +
      f.hra_annual +
      f.spec_annual +
      f.bonus_annual +
      f.reimb_annual;
    const totalExempt = f.hra_exemption;
    const totalDed =
      f.std_ded + f.invest_80c + f.invest_nps + f.invest_mediclaim;

    return `
      <tr class="section-header"><td colspan="2">PART A — GROSS SALARY</td></tr>
      <tr><td class="indent">Basic + DA</td><td class="val">${rupT(f.basic_annual)}</td></tr>
      <tr><td class="indent">House Rent Allowance Received</td><td class="val">${rupT(f.hra_annual)}</td></tr>
      <tr><td class="indent">Special Allowance &amp; Other Pay</td><td class="val">${rupT(f.spec_annual)}</td></tr>
      <tr><td class="indent">Bonus &amp; Performance Pay</td><td class="val">${rupT(f.bonus_annual)}</td></tr>
      ${f.reimb_annual ? `<tr><td class="indent">Reimbursements (Taxable Portion)</td><td class="val">${rupT(f.reimb_annual)}</td></tr>` : ""}
      <tr class="total-row"><td>Gross Salary (A)</td><td class="val">${rupT(totalGross)}</td></tr>

      <tr class="section-header"><td colspan="2">PART B — EXEMPTIONS U/S 10</td></tr>
      <tr><td class="indent">HRA Exemption [Sec 10(13A)]</td><td class="val">${rupT(f.hra_exemption)}</td></tr>
      <tr><td class="indent">Leave Travel Allowance [Sec 10(5)]</td><td class="val">0</td></tr>
      <tr class="total-row"><td>Total Exemptions (B)</td><td class="val">${rupT(totalExempt)}</td></tr>

      <tr class="section-header"><td colspan="2">PART C — DEDUCTIONS (Chap. VI-A &amp; Sec 16)</td></tr>
      <tr><td class="indent">Standard Deduction [Sec 16(ia)]</td><td class="val">${rupT(f.std_ded)}</td></tr>
      ${f.invest_80c ? `<tr><td class="indent">80C — PF + PPF + ELSS + LIC</td><td class="val">${rupT(f.invest_80c)}</td></tr>` : ""}
      ${f.invest_nps ? `<tr><td class="indent">80CCD(1B) — NPS Additional</td><td class="val">${rupT(f.invest_nps)}</td></tr>` : ""}
      ${f.invest_mediclaim ? `<tr><td class="indent">80D — Health Insurance Premium</td><td class="val">${rupT(f.invest_mediclaim)}</td></tr>` : ""}
      <tr class="total-row"><td>Total Deductions (C)</td><td class="val">${rupT(totalDed)}</td></tr>

      <tr class="section-header"><td colspan="2">TAXABLE INCOME &amp; TAX COMPUTATION (${f.regime} Regime)</td></tr>
      <tr><td class="indent" style="font-weight:700;color:#111">Net Taxable Income (A − B − C)</td><td class="val" style="font-weight:700;color:#111">${rupT(f.taxable_income)}</td></tr>
      <tr><td class="indent" colspan="2" style="color:#888;font-size:10.5px">${f.regime === "New" ? "New Tax Regime Slabs [Sec 115BAC] applied" : "Old Tax Regime Slabs applied"}</td></tr>
      ${f.slabs
        .map(
          (s) =>
            `<tr><td class="indent">${s.range}</td><td class="val">${s.tax ? rupT(s.tax) : "0"}</td></tr>`,
        )
        .join("")}
      <tr><td class="indent">Surcharge (if applicable)</td><td class="val">0</td></tr>
      <tr><td class="indent">Health &amp; Education Cess @ 4%</td><td class="val">${rupT(f.cess)}</td></tr>
      <tr class="total-row"><td>Total Tax Liability (incl. Cess)</td><td class="val">${rupT(f.tax_with_cess)}</td></tr>

      <tr class="section-header"><td colspan="2">TDS DEDUCTION SUMMARY</td></tr>
      <tr><td class="indent">Tax Deductible for Full Year</td><td class="val">${rupT(f.tax_with_cess)}</td></tr>
      <tr><td class="indent">TDS Deducted YTD (Apr 2024 – Feb 2025)</td><td class="val">${rupT(f.tds_ytd)}</td></tr>
      <tr class="grand-total"><td>Total TDS Deducted YTD</td><td class="val">${rupT(f.tds_ytd)}</td></tr>
    `;
  };

  // Update employee data when selection changes
  useEffect(() => {
    // This effect runs after render, but since we're using React state, the UI updates automatically
  }, [selectedEmployee]);

  return (
    <div className="container-fluid">
      {/* Topbar */}
      <div
        className="form-head d-flex flex-wrap align-items-center page-head mb-0"
        style={{
          borderBottom: "1px solid #dddddd",
          paddingBottom: "14px",
        }}
      >
        <div className="me-auto">
          <h2 className="font-w600 mb-0">Salary Slip</h2>
        </div>
        <div className="rightside-tabs">
          <div className="topbar-actions slip-actions">
            <select
              className="form-select"
              style={{ width: "220px" }}
              value={selectedEmployee}
              onChange={(e) => setSelectedEmployee(parseInt(e.target.value))}
            >
              {employeeList.map((e) => (
                <option value={e?.EmpId}>
                  {e?.FullName} ({e?.EmploymentId})
                </option>
              ))}
            </select>

            <select
              className="form-select"
              style={{ width: "150px" }}
              value={selectedPeriod}
              onChange={(e) => setSelectedPeriod(e.target.value)}
            >
              {masterMonthList?.map((m) => (
                <option value={m.Id}>{m.Name}</option>
              ))}
            </select>

            <button
              className="btn btn-light btn-sm"
              onClick={() => window.print()}
            >
              <i className="fa-solid fa-print"></i> Print
            </button>
            <button className="btn btn-light btn-sm">
              <i className="fa-solid fa-file-pdf"></i> PDF
            </button>
            <button
              className="btn btn-light btn-sm"
              onClick={() => history.push("/Payroll/Salary-Register")}
            >
              <i className="fa-solid fa-arrow-left"></i> Register
            </button>
          </div>
        </div>
      </div>

      {/* Page Content */}
      <div className="page-content">
        <div className="slip-container">
          <div className="slip-box">
            {/* HEADER */}
            <div className="slip-header">
              <div className="slip-logo">OG</div>
              <div>
                <div className="slip-co-name">
                  BizBrolly Solutions Pvt. Ltd.
                </div>
                <div className="slip-co-sub">Salary Slip</div>
              </div>
              <div className="slip-header-right">
                <div className="slip-period">Pay Period</div>
                <div className="slip-period-val">{selectedPeriod}</div>
              </div>
            </div>

            {/* EMPLOYEE INFO */}
            <div className="slip-emp-bar">
              <div>
                <div className="slip-emp-field-label">Employee Name</div>
                <div className="slip-emp-field-val">
                  {salarySlipEmployee?.EmployeeName}
                </div>
              </div>
              <div>
                <div className="slip-emp-field-label">Employee ID</div>
                <div className="slip-emp-field-val">
                  {salarySlipEmployee?.EmpId}
                </div>
              </div>
              <div>
                <div className="slip-emp-field-label">Designation</div>
                <div className="slip-emp-field-val">
                  {salarySlipEmployee?.CurrentDesignation}
                </div>
              </div>
              <div>
                <div className="slip-emp-field-label">Department</div>
                <div className="slip-emp-field-val">
                  {salarySlipEmployee?.CurrentDepartment}
                </div>
              </div>
              <div>
                <div className="slip-emp-field-label">Date of Joining</div>
                <div className="slip-emp-field-val">
                  {salarySlipEmployee.DateOfJoining}
                </div>
              </div>
              <div>
                <div className="slip-emp-field-label">PAN Number</div>
                <div className="slip-emp-field-val">
                  {salarySlipEmployee.PanNumber}
                </div>
              </div>
              <div>
                <div className="slip-emp-field-label">UAN</div>
                <div className="slip-emp-field-val">
                  {salarySlipEmployee.UANNumber}
                </div>
              </div>
              <div>
                <div className="slip-emp-field-label">Tax Regime</div>
                <div className="slip-emp-field-val">
                  <span
                    className={`badge ${salarySlipEmployee.regime === "New" ? "badge-account" : "badge-cash"}`}
                  >
                    {salarySlipEmployee.regime} Regime
                  </span>
                </div>
              </div>
            </div>

            {/* ATTENDANCE + BANK BAR */}
            <div
              style={{
                background: "#f8f9fa",
                borderBottom: "1px solid #eee",
                padding: "10px 28px",
                display: "flex",
                gap: "32px",
                alignItems: "center",
              }}
            >
              <div>
                <div className="slip-emp-field-label">
                  Days (Total / Present / LOP)
                </div>
                <div
                  className="slip-emp-field-val"
                  style={{ fontSize: "16px", letterSpacing: "0.5px" }}
                >
                  <span style={{ fontWeight: 700 }}>28</span> /{" "}
                  <span style={{ color: "var(--success)", fontWeight: 700 }}>
                    {currentEmployee.awd}
                  </span>{" "}
                  /{" "}
                  <span
                    style={{
                      color:
                        currentEmployee.lop > 0
                          ? "var(--danger)"
                          : "var(--text-muted)",
                      fontWeight: 700,
                    }}
                  >
                    {currentEmployee.lop}
                  </span>
                </div>
              </div>
              <div
                style={{ width: "1px", height: "36px", background: "#ddd" }}
              ></div>
              <div>
                <div className="slip-emp-field-label">Bank Account</div>
                <div className="slip-emp-field-val">
                  {salarySlipEmployee?.BankAccountNumber}
                </div>
              </div>
              <div
                style={{ width: "1px", height: "36px", background: "#ddd" }}
              ></div>
              <div>
                <div className="slip-emp-field-label">Payment Method</div>
                <div className="slip-emp-field-val">
                  <i
                    className="fa-solid fa-building-columns me-1"
                    style={{ color: "var(--brand)" }}
                  ></i>
                  NEFT to •••• {currentEmployee.bank}
                </div>
              </div>
            </div>

            {/* EARNINGS + DEDUCTIONS */}
            <div className="slip-body">
              <div
                style={{
                  display: "grid",
                  gridTemplateColumns: "1fr 1fr",
                  gap: "24px",
                }}
              >
                {/* Earnings Section */}
                <div>
                  <div className="slip-section-title">Earnings</div>
                  <table className="slip-tbl">
                    <thead>
                      <tr>
                        <th className="text-left">Component</th>
                        <th style={{ textAlign: "right" }}>Structure</th>
                        <th style={{ textAlign: "right" }}>Earned</th>
                      </tr>
                    </thead>
                    <tbody
                      dangerouslySetInnerHTML={{ __html: renderEarnings() }}
                    />
                    <tfoot>
                      <tr className="total-row">
                        <td className="fw-bold">GROSS EARNINGS</td>
                        <td style={{ textAlign: "right", fontWeight: 700 }}>
                          {rup(grossS)}
                        </td>
                        <td
                          style={{
                            textAlign: "right",
                            fontWeight: 700,
                            color: "var(--success)",
                          }}
                        >
                          {rup(grossE + additionsE)}
                        </td>
                      </tr>
                      <tr style={{ background: "#f0f4ff" }}>
                        <td
                          colSpan="3"
                          style={{
                            padding: "4px 12px",
                            fontSize: "10.5px",
                            color: "#555",
                            fontStyle: "italic",
                          }}
                        >
                          Employer contributions below are part of CTC — not
                          paid to employee
                        </td>
                      </tr>
                      <tbody
                        dangerouslySetInnerHTML={{
                          __html: renderEmployerEarnings(),
                        }}
                      />
                      <tr
                        className="total-row"
                        style={{ background: "#eef0fa" }}
                      >
                        <td className="fw-bold">TOTAL CTC (Monthly)</td>
                        <td style={{ textAlign: "right", fontWeight: 700 }}>
                          {rup(grossS + erGrossS)}
                        </td>
                        <td
                          style={{
                            textAlign: "right",
                            fontWeight: 700,
                            color: "var(--info)",
                          }}
                        >
                          {rup(grossE + erGrossE)}
                        </td>
                      </tr>
                    </tfoot>
                  </table>
                </div>

                {/* Deductions Section */}
                <div>
                  <div className="slip-section-title">Deductions</div>
                  <table className="slip-tbl">
                    <thead>
                      <tr>
                        <th className="text-left">Component</th>
                        <th style={{ textAlign: "right" }}>Amount</th>
                      </tr>
                    </thead>
                    <tbody
                      dangerouslySetInnerHTML={{ __html: renderDeductions() }}
                    />
                    <tfoot>
                      <tr className="total-row">
                        <td className="fw-bold">TOTAL DEDUCTIONS</td>
                        <td
                          style={{
                            textAlign: "right",
                            fontWeight: 700,
                            color: "var(--danger)",
                          }}
                        >
                          {rup(totalDedEmp)}
                        </td>
                      </tr>
                      <tr style={{ background: "#f0f4ff" }}>
                        <td
                          colSpan="2"
                          style={{
                            padding: "4px 12px",
                            fontSize: "10.5px",
                            color: "#555",
                            fontStyle: "italic",
                          }}
                        >
                          Employer contributions (part of CTC, not deducted from
                          salary)
                        </td>
                      </tr>
                      <tbody
                        dangerouslySetInnerHTML={{
                          __html: renderEmployerDeductions(),
                        }}
                      />
                      <tr
                        className="total-row"
                        style={{ background: "#eef0fa" }}
                      >
                        <td className="fw-bold">TOTAL CTC DEDUCTIONS</td>
                        <td
                          style={{
                            textAlign: "right",
                            fontWeight: 700,
                            color: "#3b5bdb",
                          }}
                        >
                          {rup(totalCtcDed)}
                        </td>
                      </tr>
                    </tfoot>
                  </table>
                </div>
              </div>

              {/* NET PAY */}
              <div className="slip-net">
                <div>
                  <div className="slip-net-label">Net Pay Credited to Bank</div>
                  <div className="slip-net-val">
                    ₹{netPay.toLocaleString("en-IN")}
                  </div>
                  <div className="slip-net-words">{numToWords(netPay)}</div>
                </div>
                <div className="slip-net-right">
                  <div
                    style={{
                      fontSize: "11px",
                      opacity: 0.65,
                      marginBottom: "4px",
                    }}
                  >
                    CTC This Month
                  </div>
                  <div style={{ fontSize: "18px", fontWeight: 800 }}>
                    ₹{(grossE + additionsE + erGrossE).toLocaleString("en-IN")}
                  </div>
                </div>
              </div>

              {/* TDS SUMMARY */}
              <div className="form16-box">
                <div className="form16-header">
                  <h6>
                    <i
                      className="fa-solid fa-file-contract"
                      style={{ marginRight: "6px", color: "#555" }}
                    ></i>
                    TDS Summary (FY 2024–25)
                  </h6>
                  <small>
                    Year-to-Date &nbsp;|&nbsp; Assessment Year 2025–26
                  </small>
                </div>
                <div className="form16-body">
                  <table className="f16-tbl">
                    <thead>
                      <tr>
                        <th className="text-left" style={{ width: "70%" }}>
                          Particulars
                        </th>
                        <th style={{ textAlign: "right" }}>Annual / YTD (₹)</th>
                      </tr>
                    </thead>
                    <tbody dangerouslySetInnerHTML={{ __html: buildTDS() }} />
                  </table>
                </div>
              </div>

              {/* NOTE */}
              <div
                style={{
                  marginTop: "16px",
                  background: "#f8f9fa",
                  borderRadius: "6px",
                  padding: "12px 16px",
                  fontSize: "11.5px",
                  color: "var(--text-muted)",
                  lineHeight: 1.7,
                }}
              >
                <strong style={{ color: "var(--text-dark)" }}>Note:</strong>
                This is a computer-generated payslip and does not require a
                signature. For queries contact Finance and HR personnel. TDS
                figures are indicatory and based on employee-declared investment
                proofs and regime choice. Final TDS details should be referred
                from Form 16, once released.
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SalarySlip;
